var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataBalance2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75434 4.6786H2.99392C2.51048 4.6786 2.11372 4.28184 2.11372 3.79839V2.62478C2.11372 2.14134 2.51048 1.74457 2.99392 1.74457H4.75434C5.23779 1.74457 5.63455 2.14134 5.63455 2.62478V3.79839C5.63455 4.28184 5.23779 4.6786 4.75434 4.6786Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.586806
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8557 4.38531H10.7432C10.3559 4.38531 10.0391 4.06843 10.0391 3.68113V2.74226C10.0391 2.35497 10.3559 2.03809 10.7432 2.03809H12.8557C13.243 2.03809 13.5599 2.35497 13.5599 2.74226V3.68113C13.5599 4.06843 13.243 4.38531 12.8557 4.38531Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8557 8.7857H10.7432C10.3559 8.7857 10.0391 8.46882 10.0391 8.08153V7.14265C10.0391 6.75536 10.3559 6.43848 10.7432 6.43848H12.8557C13.243 6.43848 13.5599 6.75536 13.5599 7.14265V8.08153C13.5599 8.46882 13.243 8.7857 12.8557 8.7857Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M10.0399 8.05273C10.2805 8.05273 10.48 7.85322 10.48 7.61263C10.48 7.37204 10.2805 7.17253 10.0399 7.17253H8.42622V3.65169H10.0399C10.2805 3.65169 10.48 3.45218 10.48 3.21159C10.48 2.971 10.2805 2.77148 10.0399 2.77148H5.93229C5.6917 2.77148 5.49219 2.971 5.49219 3.21159C5.49219 3.45218 5.6917 3.65169 5.93229 3.65169H7.54601V10.8401C7.54601 11.732 8.26778 12.4538 9.15972 12.4538H10.0399C10.2805 12.4538 10.48 12.2543 10.48 12.0137C10.48 11.7731 10.2805 11.5736 10.0399 11.5736H9.15972C8.75483 11.5736 8.42622 11.245 8.42622 10.8401V8.05273H10.0399Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8557 13.1871H10.7432C10.3559 13.1871 10.0391 12.8702 10.0391 12.4829V11.544C10.0391 11.1567 10.3559 10.8398 10.7432 10.8398H12.8557C13.243 10.8398 13.5599 11.1567 13.5599 11.544V12.4829C13.5599 12.8702 13.243 13.1871 12.8557 13.1871Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataBalance2);
export default __webpack_public_path__ + "static/media/DataBalance2.9dfb58284e521321a3da3f2f3eacfd11.svg";
export { ForwardRef as ReactComponent };